<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('boxinspection.secondStepInfo') }}
    </p>
    <hr />
    <div
      v-for="(_, index) in model.box_quantity || 1"
      :key="index"
      class="mb-4"
    >
      <div>
        <p>{{ $t('production.box') }} {{ index + 1 }}</p>
        <hr />
      </div>
      <div class="px-3">
        <div class="row py-3 shadow-sm" style="border: 0.5px solid #6ba6524d">
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.packer')}: *`"
              class="input-box_packer"
              ref="box_packer"
              type="number"
              v-model="model.box_packer[index]"
              :name="`boxinspection.packer_${index}`"
              v-validate="modelValidations.box_packer"
              :error="getFieldErrorByIndex('boxinspection.packer', true, index)"
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.box_weight')} ${
                box_selected && box_selected.unit_tara_weight
                  ? `(${box_selected.unit_tara_weight})`
                  : ''
              }: *`"
              class="input-box_weight"
              ref="box_weight"
              type="number"
              v-model="model.box_weight[index]"
              :name="`boxinspection.box_weight_${index}`"
              v-validate="modelValidations.box_weight"
              :error="
                getFieldErrorByIndex('boxinspection.box_weight', true, index)
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.total_clusters')}: *`"
              class="input-box_total_clusters"
              ref="box_total_clusters"
              type="number"
              v-model="model.box_total_clusters[index]"
              :name="`boxinspection.total_clusters_${index}`"
              v-validate="modelValidations.box_total_clusters"
              :error="
                getFieldErrorByIndex(
                  'boxinspection.total_clusters',
                  true,
                  index
                )
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.min_caliber')}: *`"
              class="input-box_min_caliber"
              ref="box_min_caliber"
              type="number"
              v-model="model.box_min_caliber[index]"
              :name="`boxinspection.min_caliber_${index}`"
              v-validate="modelValidations.box_min_caliber"
              :error="
                getFieldErrorByIndex('boxinspection.min_caliber', true, index)
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.max_caliber')}: *`"
              class="input-box_max_caliber"
              ref="box_max_caliber"
              type="number"
              v-model="model.box_max_caliber[index]"
              :name="`boxinspection.max_caliber_${index}`"
              v-validate="modelValidations.box_max_caliber"
              :error="
                getFieldErrorByIndex('boxinspection.max_caliber', true, index)
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.min_length')} ${
                box_selected && box_selected.unit_tara_length
                  ? `(${box_selected.unit_tara_length})`
                  : ''
              }: *`"
              class="input-box_min_lenght"
              ref="box_min_lenght"
              type="number"
              v-model="model.box_min_lenght[index]"
              :name="`boxinspection.min_length_${index}`"
              v-validate="modelValidations.box_min_lenght"
              :error="
                getFieldErrorByIndex('boxinspection.min_length', true, index)
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              :label="`${$t('boxinspection.max_length')} ${
                box_selected && box_selected.unit_tara_length
                  ? `(${box_selected.unit_tara_length})`
                  : ''
              }: *`"
              class="input-box_max_lenght"
              ref="box_max_lenght"
              type="number"
              v-model="model.box_max_lenght[index]"
              :name="`boxinspection.max_length_${index}`"
              v-validate="modelValidations.box_max_lenght"
              :error="
                getFieldErrorByIndex('boxinspection.max_length', true, index)
              "
            ></fg-input>
          </div>
          <div class="col-12 col-sm-8 col-lg-2">
            <fg-input
              type="number"
              class="input-box_max_lenght"
              :label="`${$t('boxinspection.total_fingers')}: *`"
              v-model="model.box_total_fingers[index]"
              :name="`boxinspection.total_fingers_${index}`"
              v-validate="modelValidations.box_total_fingers"
              :error="
                getFieldErrorByIndex('boxinspection.total_fingers', true, index)
              "
            >
            </fg-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        box_quantity: 1,
        box_packer: [],
        box_weight: [],
        box_total_clusters: [],
        box_min_caliber: [],
        box_max_caliber: [],
        box_min_lenght: [],
        box_max_lenght: [],
        box_total_fingers: [],
      },
      modelValidations: {
        box_packer: {
          required: true,
          max: 100,
        },
        box_weight: {
          required: true,
          decimal: 2,
          min_value: 0.1,
          max_value: 100,
        },
        box_total_clusters: {
          required: true,
          min_value: 6,
          max_value: 250,
        },
        box_min_caliber: {
          required: true,
          decimal: 2,
          min_value: 28,
          max_value: 60,
        },
        box_max_caliber: {
          required: true,
          decimal: 2,
          min_value: 28,
          max_value: 60,
        },
        box_min_lenght: {
          required: true,
          decimal: 2,
          min_value: 0,
          max_value: 30,
        },
        box_max_lenght: {
          required: true,
          decimal: 2,
          min_value: 0,
          max_value: 30,
        },
        box_total_fingers: {
          required: true,
          min_value: 6,
          max_value: 250,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinValidations],
  props: {
    box_quantity: {
      type: Number,
      default: 1,
    },
    box_selected: {
      type: Object,
      default: null,
    },
  },
  watch: {
    box_quantity: {
      handler(newVal) {
        if (newVal && newVal !== this.model.box_quantity) {
          this.model.box_quantity = newVal;
          this.handleNumberChange();
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleNumberChange() {
      const fields = [
        'box_packer',
        'box_weight',
        'box_total_clusters',
        'box_min_caliber',
        'box_max_caliber',
        'box_min_lenght',
        'box_max_lenght',
        'box_total_fingers',
      ];

      fields.forEach((field) => {
        const values = [...(this.model[field] || [])];
        this.$set(this.model, field, values.slice(0, this.model.box_quantity));
      });
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        // Validar que los valores mínimos sean menores o iguales a los máximos
        for (let i = 0; i < this.model.box_quantity; i++) {
          // Validar calibre mínimo vs máximo
          if (
            isset(this.model.box_min_caliber[i]) &&
            isset(this.model.box_max_caliber[i]) &&
            parseFloat(this.model.box_min_caliber[i]) >= parseFloat(this.model.box_max_caliber[i])
          ) {
            SweetAlert.warning(
              i18n.t('boxinspection.min_caliber_lt_max_caliber_validation', {
                maxCaliber: this.model.box_max_caliber[i],
                caja: i + 1,
              })
            );

            return false;
          }
          
          // Validar longitud mínima vs máxima
          if (
            isset(this.model.box_min_lenght[i]) &&
            isset(this.model.box_max_lenght[i]) &&
            parseFloat(this.model.box_min_lenght[i]) >= parseFloat(this.model.box_max_lenght[i])
          ) {
            SweetAlert.warning(
              i18n.t('boxinspection.min_length_lt_max_length_validation', {
                maxLength: this.model.box_max_lenght[i],
                caja: i + 1,
              })
            );

            return false;
          }
        }

        this.$emit('on-validated', this.model);

        return res;
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { box_quantity, box_inspection_boxes } = editForm;
      this.model = {
        ...this.model,
        box_quantity,
      };

      box_inspection_boxes.forEach(
        ({
          packer,
          weight,
          total_clusters,
          min_calibration,
          max_calibration,
          min_length,
          max_length,
          total_fingers,
        }) => {
          this.model.box_packer.push(packer);
          this.model.box_weight.push(weight);
          this.model.box_total_clusters.push(total_clusters);
          this.model.box_min_caliber.push(min_calibration);
          this.model.box_max_caliber.push(max_calibration);
          this.model.box_min_lenght.push(min_length);
          this.model.box_max_lenght.push(max_length);
          this.model.box_total_fingers.push(total_fingers);
        }
      );
    }
  },
};
</script>
